var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.6 39.3",
    style: {
      enableBackground: "new 0 0 79.6 39.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9182,
    y1: 22.2615,
    x2: 71.2984,
    y2: 22.2615,
    gradientTransform: "matrix(1 0 0 -1 0 39.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0090D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#0091D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    style: {
      stopColor: "#009CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#00A5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    style: {
      stopColor: "#2AAD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7049,
    style: {
      stopColor: "#4BB288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8621,
    style: {
      stopColor: "#59B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5DB77A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,11.1c-2.2,1.1-4.2,2.5-5.7,3.5v9.1c0,0.2,0.1,0.3,0.3,0.3v0h5.2h0.8c0.1,0,0.2-0.1,0.2-0.2 c0-0.1,0-0.1,0-0.1c-0.7-0.6-0.8-0.9-0.8-2.1L37.7,11.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9182,
    y1: 31.0444,
    x2: 71.2983,
    y2: 31.0444,
    gradientTransform: "matrix(1 0 0 -1 0 39.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0090D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#0091D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    style: {
      stopColor: "#009CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#00A5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    style: {
      stopColor: "#2AAD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7049,
    style: {
      stopColor: "#4BB288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8621,
    style: {
      stopColor: "#59B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5DB77A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,4.8c0-0.1-0.1-0.1-0.3,0c-3.2,0.8-9.7,3.1-13.1,4.6h-3.6c-0.1,0-0.2,0.1-0.2,0.3v3.1 C36.8,9.9,42.5,7.2,49.2,4.8C49.2,4.9,49.2,4.8,49.2,4.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9182,
    y1: 21.0141,
    x2: 71.2982,
    y2: 21.0141,
    gradientTransform: "matrix(1 0 0 -1 0 39.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0090D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#0091D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    style: {
      stopColor: "#009CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#00A5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    style: {
      stopColor: "#2AAD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7049,
    style: {
      stopColor: "#4BB288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8621,
    style: {
      stopColor: "#59B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5DB77A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.5,33.4c1.8-0.2,7.6-2.7,11.1-4.3c15.7-7.3,26-17.6,23.7-22.5c-0.6-1.2-1.9-2-3.8-2.4 c-0.1,0-0.2,0.1-0.1,0.1c0.6,0.3,1.4,0.9,1.7,1.6c1.4,2.8-1.4,7.3-6.8,12.2c-1.1,0.9-4.4,3.3-4.4,3.3c-1.3,0.5-2.9,0.6-4.1,0.5 c-5.5-0.4-6.4-3.4-6.2-5.4c0.2-2.2,2.3-4.2,6.3-4.2c1.3,0,2.3,0.2,3,0.5c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2h0l0.4-2.5 c0-0.1,0-0.3-0.2-0.3c-0.5-0.1-2.6-0.5-4.4-0.5c-7.7,0-10.7,3.9-10.9,7.7c-0.1,3.8,2.5,7,9.3,7.3c1.3,0.1,2,0,2.7-0.2 c0.1,0,0.4-0.1,0.4-0.2c0,0,0.1,0,0,0.1c-0.5,0.5-5.4,3.3-8.4,4.9c-3.4,1.7-6.6,3.2-9.8,4.4C36.2,33.2,36.2,33.4,36.5,33.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9182,
    y1: 17.4139,
    x2: 71.2983,
    y2: 17.4139,
    gradientTransform: "matrix(1 0 0 -1 0 39.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0090D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0057,
    style: {
      stopColor: "#0091D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1861,
    style: {
      stopColor: "#009CC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    style: {
      stopColor: "#00A5AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5381,
    style: {
      stopColor: "#2AAD98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7049,
    style: {
      stopColor: "#4BB288"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8621,
    style: {
      stopColor: "#59B67E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5DB77A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.3,9.4c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0.1,0,0.1c0.7,0.6,0.8,0.9,0.8,2.1l0,0V18c0,6.2,6.7,6.2,8.1,5.8 c0.1,0,0.1,0.1,0.1,0.1l0,0c-0.1,0.1-0.3,0.2-0.4,0.4c-3.9,4.6-4.4,10.1,0,11c0,0,0,0,0,0c0.3,0.1,0.3,0,0.1-0.2 c-0.7-0.4-1.2-0.9-1.5-1.6c-1.3-2.6,1.3-7.4,6-11.1v1.2l0,0c0,0.1,0.1,0.3,0.3,0.3h4.9c0.2,0,0.3-0.1,0.3-0.3v-14 c0-0.2-0.1-0.3-0.3-0.3h-4.9c-0.1,0-0.3,0.1-0.3,0.3l0,0v11.6c-1.3,0.4-6.6,1.6-6.6-3.6v-8h0c0-0.1-0.1-0.3-0.3-0.3L8.3,9.4 L8.3,9.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUic);
export default __webpack_public_path__ + "static/media/uic.913184289360ee5e49a3562f29826746.svg";
export { ForwardRef as ReactComponent };